import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initNative } from './lib/native-init';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Capacitor: inizializza status bar + splash su iOS/Android. No-op su web.
initNative().catch(err => console.warn('initNative failed:', err));

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);